import { playSound, Sound } from '~/assets/sounds';
import { SliderOld } from '~/components/ui/SliderOld';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { SettingsStages } from '../../models/Settings';
import { wallpapers } from '../../models/Wallpaper';
import { setActiveSettingsState, useLayoutDispatch } from '../../redux';
import { AppBackButton } from '../AppBackButton';
import {
	StyledBrightnessContainer,
	StyledContainer,
	StyledHead,
	StyledSliderContainer,
	StyledWallpaperButton,
	StyledWallpaperContainer,
	StyledWallpaperGrid,
	StyledWallpaperItem,
} from './AppSettingsScreen.styled';
const AppSettingsScreen = () => {
	const dispatch = useLayoutDispatch();
	const settings = useObservable(rage.phone.getSettings());

	return (
		<div>
			<StyledHead>
				<AppBackButton
					onClick={() => dispatch(setActiveSettingsState(SettingsStages.MAIN))}
				/>
				<Text>Экран / Обои</Text>
			</StyledHead>
			<StyledContainer>
				<StyledBrightnessContainer>
					<Text>Яркость</Text>
					<StyledSliderContainer>
						<SliderOld
							min={0.2}
							max={1}
							step={0.01}
							value={settings.brightness}
							onChange={(value) => rage.phone.setBrightnessValue(value)}
						/>
					</StyledSliderContainer>
				</StyledBrightnessContainer>
				<StyledWallpaperContainer>
					<Text>Выберите обои</Text>
					<StyledWallpaperGrid>
						{wallpapers.map((wallpaper, index) => (
							<StyledWallpaperItem
								key={index}
								style={{ backgroundImage: `url(${wallpaper})` }}
							>
								<StyledWallpaperButton
									disabled={settings.wallpaperIndex === index}
									onClick={() => {
										rage.phone.setActiveWallpaperIndex(index);
										playSound(Sound.ClickButton);
									}}
									onMouseEnter={() => playSound(Sound.LinkCursor)}
									tabIndex={-1}
								>
									{settings.wallpaperIndex === index
										? 'Обои установлены'
										: 'Установить обои'}
								</StyledWallpaperButton>
							</StyledWallpaperItem>
						))}
					</StyledWallpaperGrid>
				</StyledWallpaperContainer>
			</StyledContainer>
		</div>
	);
};

export { AppSettingsScreen };
